import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useAuth } from '@/hooks/useAuth';
import { logger } from '@/lib/logger';

export function usePushNotifications() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user || !Capacitor.isNativePlatform()) return;

    let mounted = true;

    async function registerPush() {
      const permission = await PushNotifications.requestPermissions();
      if (permission.receive !== 'granted') return;

      await PushNotifications.register();

      PushNotifications.addListener('registration', async (token) => {
        if (!mounted || !user) return;
        try {
          await updateDoc(doc(db, 'users', user.uid), {
            fcmTokens: arrayUnion(token.value),
          });
          logger.debug('[push] token saved:', token.value.slice(0, 20) + '…');
        } catch (err) {
          logger.error('[push] token save failed:', err);
        }
      });

      PushNotifications.addListener('registrationError', (err) => {
        logger.error('[push] registration error:', err);
      });
    }

    registerPush().catch((err) => logger.error('[push] setup failed:', err));

    return () => {
      mounted = false;
      PushNotifications.removeAllListeners();
    };
  }, [user]);
}

export async function removeFcmToken(uid: string, token: string) {
  await updateDoc(doc(db, 'users', uid), {
    fcmTokens: arrayRemove(token),
  });
}
